import { container } from 'tsyringe';

import type { IPegasusIOGateway } from '../../application/interfaces/pegasus-io.gateway';
import { PegasusIOGateway } from '../gateways/pegasus-io.gateway';

container.register<IPegasusIOGateway>('IPegasusIOGateway', {
  useClass: PegasusIOGateway,
});
